import { type DocumentNode } from 'graphql'
import { fetchRetailersClient } from 'legacy/apollo/dashboardClient'
import GraphQLAggregateError from 'legacy/common/errors/GraphQLAggregateError'

const createQuery =
  <D, V>(query: DocumentNode) =>
  async (variables: V): Promise<D> => {
    const { data, errors } = await fetchRetailersClient().query<D, V>({ query, variables })

    if (data) {
      return data
    }

    if (errors) throw new GraphQLAggregateError(errors)

    throw new Error('Unexpected Error')
  }

export default createQuery
